import { type CSSProperties, useEffect, useState } from 'react';

/**
 * Two-step destructive action, inline and on-brand (replaces window.confirm).
 * First click arms it: "Tens a certeza?" + CONFIRMAR / CANCELAR. Auto-disarms
 * after 4s or on Cancelar. `style` is the trigger's look (usually btnDanger).
 */
export function ConfirmButton({
  label,
  question = 'Tens a certeza?',
  onConfirm,
  disabled,
  style,
}: {
  label: string;
  question?: string;
  onConfirm: () => void;
  disabled?: boolean;
  style?: CSSProperties;
}) {
  const [armed, setArmed] = useState(false);
  useEffect(() => {
    if (!armed) return;
    const t = setTimeout(() => setArmed(false), 4000);
    return () => clearTimeout(t);
  }, [armed]);

  if (!armed) {
    return (
      <button type="button" onClick={() => setArmed(true)} disabled={disabled} style={style}>
        {label}
      </button>
    );
  }
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--lv-err)' }}>{question}</span>
      <button
        type="button"
        onClick={() => {
          setArmed(false);
          onConfirm();
        }}
        style={{ ...style, background: 'var(--lv-err)', color: '#fff', borderColor: 'var(--lv-err)' }}
      >
        Confirmar
      </button>
      <button
        type="button"
        onClick={() => setArmed(false)}
        style={{ ...style, background: 'transparent', color: 'var(--lv-ink)', borderColor: 'var(--lv-line)' }}
      >
        Cancelar
      </button>
    </span>
  );
}
